export interface MangaItem {
  id: number;
  title: string;
  category: string;
  status: string;
  updateTime: string;
  latestChapter: string;
  followers: string;
  rating: number;
  description: string;
  cover: string;
}

export interface CategoryItem {
  id: number;
  name: string;
  icon: string;
  count: string;
  desc: string;
}

export interface FeatureItem {
  id: number;
  icon: string;
  title: string;
  desc: string;
}

export interface StepItem {
  id: number;
  icon: string;
  title: string;
  desc: string;
}

export interface TestimonialItem {
  id: number;
  name: string;
  role: string;
  quote: string;
  avatarColor: string;
}

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export const mangaList: MangaItem[] = [
  {
    id: 1,
    title: '海边的樱花与少年',
    category: '恋爱',
    status: '连载中',
    updateTime: '今天 10:24',
    latestChapter: '第 128 话',
    followers: '23.6 万',
    rating: 9.6,
    description: '潮汐、落樱与青春心事交织，一段发生在海边的双向暗恋故事。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20couple%20standing%20by%20the%20sea%20at%20sunset%2C%20gentle%20ocean%20waves%2C%20floating%20cherry%20blossom%20petals%2C%20soft%20pastel%20pink%20and%20peach%20palette%2C%20warm%20glowing%20light%2C%20dreamy%20romantic%20atmosphere%2C%20clean%20stylized%20anime%20art%20style%2C%20minimal%20gradient%20sky%20background&width=400&height=600&seq=manga-cover-01&orientation=portrait',
  },
  {
    id: 2,
    title: '星轨彼岸',
    category: '科幻',
    status: '连载中',
    updateTime: '昨天 22:07',
    latestChapter: '第 96 话',
    followers: '15.2 万',
    rating: 9.3,
    description: '星际漂流少女穿越时空裂缝，在平行宇宙中寻找失落的故乡。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20girl%20astronaut%20floating%20in%20nebulous%20space%2C%20glowing%20stars%20and%20planet%20rings%2C%20soft%20lavender%20and%20dusty%20pink%20color%20palette%2C%20ethereal%20soft%20light%2C%20dreamy%20sci%20fi%20atmosphere%2C%20clean%20stylized%20anime%20art%20style%2C%20minimal%20starry%20space%20background&width=400&height=600&seq=manga-cover-02&orientation=portrait',
  },
  {
    id: 3,
    title: '除妖师手札',
    category: '奇幻',
    status: '连载中',
    updateTime: '昨天 20:15',
    latestChapter: '第 210 话',
    followers: '18.9 万',
    rating: 9.4,
    description: '半妖少女执笔降妖，在妖怪与人类的边界守护一方安宁。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20girl%20holding%20a%20glowing%20scroll%20with%20fox%20spirit%20and%20soft%20magic%20glow%2C%20warm%20cream%20and%20coral%20palette%2C%20traditional%20eastern%20fantasy%20atmosphere%2C%20clean%20stylized%20anime%20art%20style%2C%20minimal%20soft%20gradient%20background&width=400&height=600&seq=manga-cover-03&orientation=portrait',
  },
  {
    id: 4,
    title: '剑与茶室',
    category: '热血',
    status: '已完结',
    updateTime: '2026.08.02',
    latestChapter: '全 182 话',
    followers: '21.3 万',
    rating: 9.2,
    description: '少年剑客在闹市开起茶室，一边泡茶一边斩断恩怨情仇。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20samurai%20youth%20holding%20a%20sword%20in%20front%20of%20a%20traditional%20teahouse%2C%20falling%20leaves%2C%20warm%20amber%20and%20rose%20palette%2C%20action%20wuxia%20atmosphere%2C%20clean%20stylized%20anime%20art%20style%2C%20minimal%20warm%20gradient%20background&width=400&height=600&seq=manga-cover-04&orientation=portrait',
  },
  {
    id: 5,
    title: '末班车幻想',
    category: '悬疑',
    status: '连载中',
    updateTime: '3 天前',
    latestChapter: '第 54 话',
    followers: '9.8 万',
    rating: 8.9,
    description: '每晚最后一班地铁，总会载着一群来自不同时代的乘客。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20mysterious%20night%20train%20with%20glowing%20windows%20and%20fog%2C%20a%20silhouette%20passenger%2C%20soft%20mauve%20and%20deep%20plum%20palette%2C%20suspenseful%20nocturnal%20atmosphere%2C%20clean%20stylized%20anime%20art%20style%2C%20minimal%20dark%20gradient%20background&width=400&height=600&seq=manga-cover-05&orientation=portrait',
  },
  {
    id: 6,
    title: '神明也在打工',
    category: '治愈',
    status: '连载中',
    updateTime: '今天 08:40',
    latestChapter: '第 78 话',
    followers: '12.4 万',
    rating: 9.5,
    description: '退休神明在便利店值夜班，用微小的善意温暖每个晚归的人。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20kind%20goddess%20in%20apron%20working%20at%20a%20cozy%20convenience%20store%20at%20night%2C%20warm%20glowing%20shelves%2C%20soft%20pink%20and%20cream%20palette%2C%20healing%20heartwarming%20atmosphere%2C%20clean%20stylized%20anime%20art%20style%2C%20minimal%20soft%20indoor%20background&width=400&height=600&seq=manga-cover-06&orientation=portrait',
  },
  {
    id: 7,
    title: '机甲少女阿零',
    category: '机战',
    status: '连载中',
    updateTime: '5 天前',
    latestChapter: '第 143 话',
    followers: '11.7 万',
    rating: 9.0,
    description: '废弃机库里的少女驾驶着旧机甲，守护支离破碎的城市。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20girl%20pilot%20inside%20a%20giant%20mecha%20cockpit%2C%20warm%20rose%20and%20gunmetal%20palette%2C%20soft%20cockpit%20glow%2C%20mecha%20action%20atmosphere%2C%20clean%20stylized%20anime%20art%20style%2C%20minimal%20dark%20industrial%20gradient%20background&width=400&height=600&seq=manga-cover-07&orientation=portrait',
  },
  {
    id: 8,
    title: '猫咪侦探所',
    category: '推理',
    status: '已完结',
    updateTime: '2026.07.15',
    latestChapter: '全 66 话',
    followers: '8.6 万',
    rating: 8.8,
    description: '会说话的橘猫开起侦探事务所，专接那些离奇的小案子。',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20smart%20orange%20cat%20wearing%20a%20detective%20coat%20holding%20a%20magnifying%20glass%2C%20soft%20peach%20and%20cream%20palette%2C%20cozy%20mystery%20atmosphere%2C%20clean%20stylized%20anime%20art%20style%2C%20minimal%20soft%20warm%20gradient%20background&width=400&height=600&seq=manga-cover-08&orientation=portrait',
  },
];

export const categories: CategoryItem[] = [
  { id: 1, name: '恋爱', icon: 'ri-heart-3-line', count: '8.2 万', desc: '青涩心动与双向奔赴' },
  { id: 2, name: '热血', icon: 'ri-fire-line', count: '6.5 万', desc: '战斗成长与羁绊' },
  { id: 3, name: '奇幻', icon: 'ri-magic-line', count: '5.1 万', desc: '魔法与异世冒险' },
  { id: 4, name: '科幻', icon: 'ri-rocket-2-line', count: '4.3 万', desc: '星际与未来想象' },
  { id: 5, name: '悬疑', icon: 'ri-spy-line', count: '3.9 万', desc: '烧脑谜案与反转' },
  { id: 6, name: '治愈', icon: 'ri-sun-line', count: '3.2 万', desc: '温暖日常与救赎' },
  { id: 7, name: '机战', icon: 'ri-robot-2-line', count: '2.8 万', desc: '机甲轰鸣与守护' },
  { id: 8, name: '推理', icon: 'ri-search-line', count: '2.4 万', desc: '细密线索与真相' },
];

export const features: FeatureItem[] = [
  {
    id: 1,
    icon: 'ri-notification-3-line',
    title: '实时追更提醒',
    desc: '作品更新第一时间推送，追更不怕漏，热门佳作一个都不错过。',
  },
  {
    id: 2,
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存下载',
    desc: '一键缓存整部章节，通勤路上、无网络时也能畅快阅读。',
  },
  {
    id: 3,
    icon: 'ri-bookmark-3-line',
    title: '收藏订阅管理',
    desc: '书架自动整理订阅作品，更新状态一目了然，轻轻松松管理追更清单。',
  },
  {
    id: 4,
    icon: 'ri-cloud-line',
    title: '多端进度同步',
    desc: '追更进度云端自动同步，手机、平板、电脑无缝衔接，随时接着看。',
  },
  {
    id: 5,
    icon: 'ri-sparkling-2-line',
    title: '智能猜你喜欢',
    desc: '根据阅读偏好推荐同类型佳作，帮你发现更多值得追的好漫画。',
  },
  {
    id: 6,
    icon: 'ri-eye-close-line',
    title: '纯净阅读体验',
    desc: '干净清爽的阅读界面，专注剧情本身，不受多余打扰。',
  },
];

export const steps: StepItem[] = [
  {
    id: 1,
    icon: 'ri-search-line',
    title: '搜索收藏作品',
    desc: '在书库搜索想追的漫画，点击收藏加入书架，开始建立追更清单。',
  },
  {
    id: 2,
    icon: 'ri-notification-4-line',
    title: '更新自动提醒',
    desc: '作品一旦更新，第一时间收到提醒，追更进度一目了然，再也不用反复刷新。',
  },
  {
    id: 3,
    icon: 'ri-download-2-line',
    title: '一键缓存章节',
    desc: '按需缓存单章或整部，节省流量，离线也能安心阅读。',
  },
  {
    id: 4,
    icon: 'ri-book-open-line',
    title: '随时随地阅读',
    desc: '地铁、通勤、午休，打开就能读，进度自动同步到所有设备。',
  },
];

export const testimonials: TestimonialItem[] = [
  {
    id: 1,
    name: '小鹿与海',
    role: '追更 2 年的用户',
    quote: '以前总忘更新，现在提醒一响我就知道新的一话来了，通勤路上直接缓存好，太省心了。',
    avatarColor: 'bg-primary-100 text-primary-700',
  },
  {
    id: 2,
    name: '青柠气泡',
    role: '漫画收藏党',
    quote: '书架整理得特别清楚，追了十几部也不乱，多设备进度同步让我在家和公司都能接着看。',
    avatarColor: 'bg-accent-100 text-accent-700',
  },
  {
    id: 3,
    name: '夜行猫',
    role: '离线阅读用户',
    quote: '缓存下载真的香，地铁没信号也能流畅看完最新章节，画质还特别清晰，体验很棒。',
    avatarColor: 'bg-secondary-100 text-secondary-800',
  },
];

export const faqs: FaqItem[] = [
  {
    id: 1,
    question: '追更提醒及时准确吗？',
    answer: '樱花漫画会在作品更新后第一时间进行检测并推送提醒，通常与官方更新几乎同步。你还可以自定义提醒时间，避免在深夜被打扰。',
  },
  {
    id: 2,
    question: '缓存下载后可以离线阅读多久？',
    answer: '缓存章节会一直保存在你的设备中，直到你手动删除。缓存前请预留足够的存储空间，离线阅读无需消耗流量。',
  },
  {
    id: 3,
    question: '收藏订阅是免费的吗？',
    answer: '是的，收藏、订阅与追更提醒功能完全免费。你可以自由建立书架，管理所有关注的作品，无需任何费用。',
  },
  {
    id: 4,
    question: '追更进度会同步到不同设备吗？',
    answer: '会的。登录同一账号后，阅读进度会自动云端同步，手机、平板与电脑之间无缝衔接，随时切换到任意设备接着阅读。',
  },
  {
    id: 5,
    question: '缓存占用的空间大吗？如何管理？',
    answer: '你可以按需缓存单章或整部作品，并在设置中随时查看缓存占用、一键清理。支持画质选择，高清与省流模式自由切换。',
  },
  {
    id: 6,
    question: '支持哪些设备使用？',
    answer: '樱花漫画支持手机、平板与电脑等主流设备，通过浏览器即可访问，无需额外下载，登录账号即可同步所有追更数据。',
  },
];